import axios from 'axios'
import { pageLabel } from './userActivity'

// Suivi d'utilisation : chaque navigation enregistre la page consultée,
// et le temps passé (onglet visible uniquement) sur la page précédente.

const IGNORED_ROUTES = new Set(['login', 'reset-password'])

let pendingViewId = null
let visibleMs = 0
let visibleSince = null

const pauseTimer = () => {
  if (visibleSince) visibleMs += Date.now() - visibleSince
  visibleSince = null
}

const resumeTimer = () => {
  if (!visibleSince && document.visibilityState === 'visible') visibleSince = Date.now()
}

if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    document.visibilityState === 'visible' ? resumeTimer() : pauseTimer()
  })
}

export async function trackPageView(to, from) {
  if (!localStorage.getItem('token')) return
  const name = to.name ? String(to.name) : null
  if (IGNORED_ROUTES.has(name) || name?.startsWith('error-')) return
  // Simple changement de query/hash sur la même page : pas une nouvelle vue
  if (from?.name && from.path === to.path) return

  pauseTimer()
  const previousDuration = Math.round(visibleMs / 1000)
  const previous = pendingViewId

  visibleMs = 0
  resumeTimer()

  pendingViewId = (async () => {
    const previousId = previous ? await previous.catch(() => null) : null
    const { data } = await axios.post('/api/activity/page-view', {
      path: to.path.slice(0, 255),
      route_name: name,
      title: pageLabel(name, to.path).slice(0, 150),
      previous_id: previousId,
      previous_duration: previousId ? previousDuration : null
    })
    return data?.data?.id ?? null
  })()

  pendingViewId.catch(() => {})
}
